export default "__VITE_ASSET__BLfRJmzq__"